import React, { useState, useEffect } from "react";
import SimpleBar from 'simplebar-react';
import { useLocation, Link, useHistory } from "react-router-dom";
import { CSSTransition } from 'react-transition-group';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChartPie, faUsers, faCalendarAlt, faMoneyBillWave,
  faClipboardList, faTrophy, faUserCog, faSignOutAlt,
  faTimes, faCog, faSms
} from "@fortawesome/free-solid-svg-icons";
import { Nav, Image, Button, Navbar, Dropdown } from '@themesberg/react-bootstrap';
import { jwtDecode } from "jwt-decode";

import { Routes } from "../routes";
import AkasbLogo from "../assets/img/logo_akasb.png";

export default () => {
  const location = useLocation();
  const { pathname } = location;
  const [show, setShow] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [userActive, setUserActive] = useState(false);
  const showClass = show ? "show" : "";
  const history = useHistory();

  useEffect(() => {
    const token = localStorage.getItem("token") || sessionStorage.getItem("token");
    if (token) {
      try {
        const decodedToken = jwtDecode(token);

        const roleClaim = decodedToken["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
        const isAtivoClaim = decodedToken["isAtivo"];

        setUserRole(roleClaim ? roleClaim.toLowerCase() : 'user');
        setUserActive(isAtivoClaim === "1");
      } catch {
        setUserRole('user');
        setUserActive(false);
      }
    }
  }, []);

  const onCollapse = () => setShow(!show);

  const hasPermission = (roles, title) => {
    if (!userRole || !roles) return false;

    if (roles.includes('all')) return true;

    if (['admin', 'treinador', 'tesoureiro'].includes(userRole)) {
      return roles.includes(userRole);
    }

    if (userRole === 'user') {
      if (title === 'Praticante(s)') return true;
      return userActive && roles.includes(userRole);
    }

    return false;
  };

  const NavItem = ({ title, link, icon, image, roles, className, iconClassName, onClick }) => {
    const navItemClassName = pathname === link ? "active" : "";

    if (!hasPermission(roles, title)) return null;

    return (
        <Nav.Item className={navItemClassName} onClick={() => setShow(false)}>
          <Nav.Link
              as={Link}
              to={link}
              className={`d-flex justify-content-start align-items-center ${className || ''}`}
              onClick={onClick}
          >
          <span>
            {icon && <span className={`sidebar-icon ${iconClassName || ''}`}><FontAwesomeIcon icon={icon} /></span>}
            {image && <Image src={image} width={35} height={35} className="sidebar-icon svg-icon" />}
            <span className="sidebar-text">{title}</span>
          </span>
          </Nav.Link>
        </Nav.Item>
    );
  };

  return (
      <>
        <Navbar expand={false} collapseOnSelect variant="dark" className="navbar-theme-primary px-4 d-md-none">
          <Navbar.Brand className="me-lg-5" as={Link} to="/connect/dashboardAdmin">
            <Image src={AkasbLogo} style={{ height: 35 }} className="navbar-brand-light" />
          </Navbar.Brand>
          <Navbar.Toggle as={Button} aria-controls="main-navbar" onClick={onCollapse}>
            <span className="navbar-toggler-icon" />
          </Navbar.Toggle>
        </Navbar>

        <CSSTransition timeout={300} in={show} classNames="sidebar-transition">
          <SimpleBar className={`collapse ${showClass} sidebar d-md-block bg-primary text-white`} style={{ backgroundColor: '#1e1d45' }}>
            <div className="sidebar-inner px-4 pt-3">

              {/* Topo fixo */}
              <div className="d-flex align-items-center mb-4">
                <Image src={AkasbLogo} style={{ height: 35, marginRight: 10 }} />
                <span className="sidebar-title text-white fw-bold" style={{ fontSize: '1.2rem' }}>AKASB Connect</span>
              </div>

              <div className="user-card d-flex d-md-none align-items-center justify-content-between justify-content-md-center pb-4">
                <div className="d-flex align-items-center">
                </div>
                <Nav.Link className="collapse-close d-md-none" onClick={onCollapse}>
                  <FontAwesomeIcon icon={faTimes} />
                </Nav.Link>
              </div>

              <Nav className="flex-column pt-3 pt-md-0">
                {/* Admin/Treinador/Tesoureiro */}
                <NavItem title="Visão Geral" link="/connect/dashboard/admin" icon={faChartPie} roles={['admin','treinador','tesoureiro']} />
                <NavItem title="Praticantes" link="/connect/praticantes/admin" icon={faUsers} roles={['admin','treinador','tesoureiro']} />
                <NavItem title="Turmas" link="/connect/turmas/admin" icon={faClipboardList} roles={['admin','treinador']} />
                <NavItem title="Aulas" link="/connect/aulas/admin" icon={faCalendarAlt} roles={['admin','treinador']} />
                <NavItem title="Eventos" link="/connect/eventos/admin" icon={faTrophy} roles={['admin','treinador']} />
                <NavItem title="Pagamentos" link="/connect/pagamentos/admin" icon={faMoneyBillWave} roles={['admin','tesoureiro']} />
                <NavItem title="Comunicações" link="/connect/mensagens/admin" icon={faSms} roles={['admin','treinador','tesoureiro']} />

                {/* User ativo */}
                {userRole === 'user' && userActive && (
                    <>
                      <NavItem title="Visão Geral" link="/connect/dashboard/user" icon={faChartPie} roles={['user']} />
                      <NavItem title="Praticante(s)" link="/connect/praticantes/user" icon={faUsers} roles={['user']} />
                      <NavItem title="Aulas" link="/connect/aulas/user" icon={faCalendarAlt} roles={['user']} />
                      <NavItem title="Eventos" link="/connect/eventos/user" icon={faTrophy} roles={['user']} />
                      <NavItem title="Pagamentos" link="/connect/pagamentos/user" icon={faMoneyBillWave} roles={['user']} />
                      <NavItem title="Notificações" link="/connect/mensagens/user" icon={faSms} roles={['user']} />
                    </>
                )}

                {/* User não ativo: apenas praticante(s) */}
                {userRole === 'user' && !userActive && (
                    <NavItem title="Praticante(s)" link="/connect/praticantes/user" icon={faUsers} roles={['user']} />
                )}

                <Dropdown.Divider className="my-3 border-white" />

                {/* Links comuns */}
                <NavItem title="Utilizadores" link="/connect/utilizadores/admin" icon={faUserCog} roles={['admin']} />
                <NavItem title="Meu Perfil" link="/connect/perfil" icon={faCog} roles={['all']} />
                <NavItem
                    title="Sair"
                    link="/"
                    icon={faSignOutAlt}
                    roles={['all']}
                    className="text-danger"
                    iconClassName="text-danger"
                    onClick={(e) => {
                      e.preventDefault();
                      if (window.confirm("Tem a certeza que quer sair?")) {
                        localStorage.removeItem("token");
                        localStorage.removeItem("refreshToken");
                        sessionStorage.removeItem("token");
                        sessionStorage.removeItem("refreshToken")
                        window.location.href = "/";
                      }
                    }}
                />
              </Nav>
            </div>
          </SimpleBar>
        </CSSTransition>
      </>
  );
};
